import { convertMinutesToHours } from '@nile/mangifera/src/Utils/helpers';
import { Timer } from '@styled-icons/remix-fill';
import {
  ALL_MODULES,
  AsyncCheckbox,
  AsyncRadio,
  AsyncSelect,
  CustomDateField,
  CustomTextField,
  SecureText
} from '@nile/components';
import { isEmpty, cloneDeep } from 'lodash';
import React from 'react';

function CustomSecureTextCell(props) {
  const { cell } = props;
  const ticket = cell.row.original;
  const entityIdMap = {
    TICKET: 'ticketId',
    REQUESTER: ''
  };
  const { field, editable, actions, module, getCustomFieldValue } = cell.column;
  let fieldValue = getCustomFieldValue
    ? getCustomFieldValue(ticket, field)
    : ticket?.customFields?.[field.name] || '';
  if (fieldValue && field.uiDataType === 'select') {
    fieldValue = {
      name: fieldValue,
      value: fieldValue,
      label: fieldValue
    };
  } else if (fieldValue && field.uiDataType === 'multi_select') {
    fieldValue = fieldValue.map((el) => {
      return {
        name: el,
        value: el,
        label: el
      };
    });
  }
  const updateSelection = (f, val) => {
    const allCustomFieldValues = !isEmpty(ticket.customFields)
      ? cloneDeep(ticket.customFields)
      : {};
    if (val?.label) {
      allCustomFieldValues[f.name] = val.label;
    } else if (f.uiDataType === 'multi_select') {
      allCustomFieldValues[f.name] = val.map((el) => el.label);
    } else {
      allCustomFieldValues[f.name] = val;
    }
    if (actions.save)
      actions.save({ customFields: allCustomFieldValues }, ticket, props.data);
  };
  const getEntityId = () => {
    if (module?.includes('ac') || module?.includes('Password')) {
      return ticket.assetId; // TODO Kannan refactor
    }
    switch (module) {
      case ALL_MODULES.ticket:
        return ticket.ticketId;
      case ALL_MODULES.companyUser:
        return ticket.userId;
      case ALL_MODULES.requester:
        return ticket.user.userId;
      case 'WorkStation':
        return ticket.assetId;
      default:
        return ticket.ticketId;
    }
  };
  return (
    <div className="full-height">
      <SecureText
        defaultValue={fieldValue}
        isTotp={field?.uiDataType === 'totp'}
        timer={field?.uiDataType === 'totp'}
        updateSelection={(v) => {
          updateSelection(field, v);
        }}
        value={fieldValue}
        ticket={ticket}
        field={field}
        editable={editable}
        inlineEdit
        module={module || ALL_MODULES.ticket}
        entityId={getEntityId()}
      />
    </div>
  );
}

export default CustomSecureTextCell;
